import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-placeholder-page',
  templateUrl: './placeholder-page.component.html',
  styleUrl: './placeholder-page.component.css',
  imports: [MegamenuComponent, FooterComponent]
})
export class PlaceholderPageComponent implements OnInit {
  pageTitle = 'Page';
  
  constructor(private route: ActivatedRoute) {}
  
  ngOnInit() {
    // Get the page title from route data or URL
    this.route.data.subscribe(data => {
      this.pageTitle = data['title'] || 'Page';
    });
  }
}